// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"audienceVideoMessage_mainContainer__2aW_g","userImg":"audienceVideoMessage_userImg__1Ews0","messageContainer":"audienceVideoMessage_messageContainer__30bHO"};